import { Navigate, Outlet } from "react-router-dom";
import paths from "routes/paths";
const RequiredAuth = () => {
  const bearerToken = localStorage.getItem("bearerToken");

  return bearerToken ? <Outlet /> : <Navigate to={paths.login} replace />;
};

export default RequiredAuth;
